/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "sa-east-1",
    "aws_appsync_graphqlEndpoint": "https://t55gjdtdmvhp5bfc4wtu6yygwa.appsync-api.sa-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "sa-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-swyipcpkzfgchh2hixruzuajim",
    "aws_cognito_identity_pool_id": "sa-east-1:bc628537-8cae-4668-affd-30a8b51f8c17",
    "aws_cognito_region": "sa-east-1",
    "aws_user_pools_id": "sa-east-1_qUM5Ly0TF",
    "aws_user_pools_web_client_id": "7r6oj9thongfmmt3ahtfmvshln",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "eventflow-storage-a71837fd145149-staging",
    "aws_user_files_s3_bucket_region": "sa-east-1"
};


export default awsmobile;
